import { Button } from 'hljd'
import React from 'react'
import styles from './style.module.less'
export const getData = store => {
  const { getCashFlowStatus, goBackHome } = store
  return {
    success: {
      type: 'success',
      icon: '//qnm.hunliji.com/o_1es2d2isg104d50478ldge1hdc9.png',
      title: '支付成功',
      extra: (
        <Button
          type="primary"
          className={styles.resultButton}
          onClick={goBackHome}
        >
          返回首页
        </Button>
      )
    },
    error: {
      type: 'error',
      icon: '//qnm.hunliji.com/o_1es2d2lg0lkc1ff91q521hrjd4be.png',
      title: '支付返回结果失败',
      subtitle: (
        <>
          <div>多次重试失败，请不要重复提交</div>
          <div>
            请于周一～周日 9:00-21:00 联系商家客服 400-159-9090 进行反馈
          </div>
        </>
      ),
      extra: (
        <Button
          type="primary"
          className={styles.resultButton}
          onClick={getCashFlowStatus}
        >
          重试
        </Button>
      )
    },
    loading: {
      type: 'loading',
      title: '等待支付返回结果',
      subtitle: '结果返回前，请不要重复提交或关闭窗口。'
    }
  }
}
